const apiEndPointsList = {
    sector: {
        NESTED_SECTORS: `/v1/general/sector/nestedSector`,
        SECTOR_BY_ID: (id) => `/v1/general/sector/${id}`,
    },

    project: {
        GET_ALL_PROJECT: `/v1/general/project`,
        SEARCH_PROJECT: `/v1/general/project/search`,
        COUNT_VIEW_WEB_APP: `/v1/general/project/countView/webApp`,
        NEW_PLATFORM_PUBLIC: `/v1/general/project-statistics/public/new-platform`,
        GET_ALL_FIELDS: `/v1/general/project/fields`,
        NEW_PLATFORM_LOCATION: `/v1/general/project-statistics/public/projects-by-location`,
    },

    contact: {
        SEND_CONTACT_FORM: `/v1/general/contact`,
    },
}

export default apiEndPointsList;


